import {subdebug} from '@sanity/cli-core'

export const devDebug = subdebug('dev')
